<template>
  <div class="questionnaire-question-content">

    <div v-if="ifFirstPage">
      <div class="questionnaire-question-sentence"> {{ question }}</div>

      <div class="questionnaire-question-question">
        Rédigez un texte qui présente vos arguments et donne votre opinion sur le sujet suivant. Il n'y a pas de bonnes ou de mauvaises réponses, seule votre argumentation compte. Relisez-vous et soignez la construction (introduction, argumentation, conclusion), votre expression et votre orthographe.
      </div>

      <div class="questionnaire-question-question">
        300 mots maximum.
      </div>
    </div>

    <div v-else>
      <div class="questionnaire-question-sentence">
        {{ question }}
      </div>

      <div class="questionnaire-question-response">
                <textarea id="responseArea" v-model="answer" autocapitalize="none" autocomplete="off" autocorrect="off" class="questionnaire-question-response-textarea" rows="15" spellcheck="false" x-webkit-speech="off" @input="compterMot()">
                </textarea>
        <p>Nombre de mots: <span id="afficher">{{ nombre }}</span>/300</p>
        <p v-if="nombre >= 300" class="text-danger"><strong>Limite maximale atteinte.</strong></p>
        <p class="dashboard-section-header-title--warning">APFORM s'inscrit dans une démarche d'intégrité académique. Les tests d'argumentation peuvent faire l'objet d'une analyse via un outil spécialisé <strong>anti-fraude/plagiat</strong></p>

        <button :disabled='isDisabled()' class="btn btn-primary btn-block" @click="terminer">
          <span>Envoyer ma réponse</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {inject, nextTick, onMounted, ref, watch} from 'vue';
import UserService from "@/services/user.service";

const props = defineProps({
  question: String,
  response: String,
  propositions: Array
});

const ifFirstPage = ref(true);
const answer = ref(null);
const isDisabledStatus = ref(true);
const nombre = ref(0);
const timerSave = ref(0);
let indexQuestion = null;
let domainId = null;

const parent = inject('parentContext');

const isDisabled = () => {
  return isDisabledStatus.value;
};

const compterMot = () => {
  if (null === answer.value) {
    return;
  }
  let answerText = answer.value.trim();
  let wordCount = answerText.length === 0 ? 0 : answerText.split(/\s+/).length;

  if (wordCount > 300) {
    const words = answerText.split(/\s+/);
    answer.value = words.slice(0, 300).join(' ');
    nombre.value = 300;
  } else {
    nombre.value = wordCount;
  }

  isDisabledStatus.value = (answerText.length === 0 || nombre.value === 0 || nombre.value > 300);
};

const terminer = () => {
  answer.value = document.getElementById('responseArea').value;

  answer.value = answer.value.replace(/"/g, "'");

  if (parent && parent.showModalFinish) {
    parent.showModalFinish();
  }
};

watch(answer, (text) => {
  if (document.getElementById('responseArea')) {
    clearTimeout(timerSave.value);

    let idUserTest = parent?.idUserTest;

    timerSave.value = window.setTimeout(() => {
      let formattedText = text.replace(/\n/g, "<br />");
      UserService.saveAnswerQuestion(idUserTest, 1, formattedText).then(
          (response) => {
            return response;
          }
      );
    }, 1000 * 5);
  }
});

onMounted(() => {
  indexQuestion = parent?.indexQuestion;
  domainId = parent?.domainId;

  UserService.getUserTestQuestions(domainId).then(
      (response) => {
        var arrayResponses = response.data.responses;
        var index = (indexQuestion - 1);

        if (arrayResponses[index]) {
          answer.value = arrayResponses[index]['answer'];
          answer.value = answer.value.replace(/<br\s*\/?>/g, "\n");
          compterMot();
        }

        nextTick(()=>{
          if (parent) {
            parent.pageIsLoaded = true
          }
        })
      }
  );
});

defineExpose({
  ifFirstPage,
  answer
});
</script>
